module.exports = __webpack_public_path__ + "static/Srinivasa-7-f8980df6912f77c83778c670e339c242.jpeg";